import { render, staticRenderFns } from "./FixedMenuMobile.vue?vue&type=template&id=971464ba&scoped=true"
import script from "./FixedMenuMobile.vue?vue&type=script&lang=js"
export * from "./FixedMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./FixedMenuMobile.vue?vue&type=style&index=0&id=971464ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971464ba",
  null
  
)

export default component.exports